import { render, staticRenderFns } from "./BankAccountDialog.vue?vue&type=template&id=c12fd0fe"
import script from "./BankAccountDialog.vue?vue&type=script&lang=js"
export * from "./BankAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports